import React, {Component} from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery';
import {
    SEARCH_CARDS_SUCCESS,
    STATUS_PENDING,
    STATUS_APPROVED,
    STATUS_RETURNED,
    STATUS_DECLINED
} from '../constants/Cards'

export default class Card extends Component {

    onEditCardBtnClick(e) {
        $('#cardForm').modal({show: true, backdrop: 'static'});
        this.props.editCard(e);
    }

    onDeleteCardBtnClick(e) {
        const id = $(e.target).data('id');
        const title = $(e.target).data('title');
        const text = $(e.target).data('text');

        $('#confirmationDialogId').val(id);
        $('#confirmationDialogTitle').html(title);
        $('#confirmationDialogText').html(text);
    }

    isKeyword(text) {
        const inputSearch = $('#inputSearch').val();

        if (inputSearch === '') {
            return false;
        }

        if (inputSearch === undefined) {
            return false;
        }

        const keywords = inputSearch.split(' ');
        for (const keyword of keywords) {
            const regexp = new RegExp(keyword, 'i');
            if (text.search(regexp) !== -1) {
                return true;
            }
        }
        return false;
    }

    highlightText(text) {
        if (this.props.action !== SEARCH_CARDS_SUCCESS) {
            return text;
        }

        const inputSearch = $('#inputSearch').val();
        if (inputSearch === undefined) {
            return text;
        }

        const keywords = inputSearch.split(' ');
        for (const keyword of keywords) {
            text = text.replace(keyword, '<span class=" text-highlight">' + keyword + '</span>');
        }

        return text;
    }

    static status(status) {
        switch (status) {
            case STATUS_APPROVED:
                return 'Hyväksytty';

            case STATUS_RETURNED:
                return 'Palautettu';

            case STATUS_DECLINED:
                return 'Hylätty';

            case STATUS_PENDING:
                return 'Odottaa';

            default:
                return 'Odottaa';
        }
    }

    render() {
        const {id, companyName, status, firstName, lastName, starts, ends, created} = this.props.card;
        const fetching = this.props.fetching;

        return <div className='col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3'>
            <button className={'btn btn-card ' + (status || STATUS_PENDING)} onClick={::this.onEditCardBtnClick.bind(this, id)} disabled={fetching}>
              <div className='card'>
                <div className='card-block'>
                    <p className={'float-right small uppercase ' +
                      (status === STATUS_APPROVED && 'text-success' ||
                       status === STATUS_DECLINED && 'text-danger'||
                       status === STATUS_RETURNED && 'text-muted'||
                       (status === STATUS_PENDING || !status) && 'text-warning')}>
                      {this.props.translations['cardStatus.' + Card.status(status)]}
                    </p>
                    {this.props.user.isAdmin &&
                    <h5 className='card-title'><span
                        className={this.isKeyword(companyName) ? ' text-highlight' : ''}>{companyName}</span></h5>
                    }
                    <h4 className='card-title'><span
                        className={this.isKeyword(lastName) ? ' text-highlight' : ''}>{lastName}</span>, <span
                        className={this.isKeyword(firstName) ? ' text-highlight' : ''}>{firstName}</span></h4>
                    <p className={'date-period card-text' + this.props.user.isAdmin && created ? 'mb-2' : ''}>{starts} - {ends}</p>
                    {/* {!this.props.user.isAdmin &&
                        <p className={'date-period card-text' + this.props.user.isAdmin && createdAt ? 'mb-2' : ''}>{starts} - {ends}</p>
                    }
                    {this.props.user.isAdmin && starts && ends &&
                        <div className='text-muted'>
                            <p className={'date-period card-text' + this.props.user.isAdmin && createdAt ? 'mb-2' : ''}>Kesto: {starts} - {ends}</p>
                        </div>
                    }
                    {this.props.user.isAdmin && starts && !ends &&
                        <div className='text-muted'>
                            <p className={'date-period card-text' + this.props.user.isAdmin && createdAt ? 'mb-2' : ''}>Alkaa: {starts} - {ends}</p>
                        </div>
                    } */}
                    {this.props.user.isAdmin && created &&
                        <div style={{ color: 'rgb(146 144 144)' }}>
                            <p className='date-period card-text'>{this.props.translations['cardForm.Saapunut']}: {created}</p>
                        </div>
                    }
                </div>
              </div>
            </button>
        </div>
    }
}

Card.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    starts: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    companyId: PropTypes.string.isRequired,
    translations: PropTypes.object
  })
};



// WEBPACK FOOTER //
// ./src/components/Card.js